import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Version wird beim Build gesetzt
const CURRENT_VERSION = process.env.REACT_APP_VERSION || '2026.03.06.1';

/**
 * Auto-Refresh bei neuer Version
 * Checkt bei jeder Navigation ob neue Version deployed wurde
 * Wenn ja → automatischer Hard Refresh
 */
const useVersionCheck = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Beim ersten Laden nicht checken (sonst infinite loop)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Version checken
    const checkVersion = async () => {
      try {
        // Cache umgehen mit timestamp
        const res = await fetch(`/version.json?t=${Date.now()}`);
        if (!res.ok) return;
        
        const data = await res.json();
        
        if (data.version && data.version !== CURRENT_VERSION) {
          console.log(`🔄 Neue Version erkannt: ${data.version} (aktuell: ${CURRENT_VERSION})`);
          // Hard refresh - neue Version laden
          window.location.reload(true);
        }
      } catch (err) {
        // Stille Fehler - nicht kritisch
        console.debug('Version check failed:', err);
      }
    };

    checkVersion();
  }, [location.pathname]); // Bei jeder Navigation
};

export default useVersionCheck;
